import { useQuery } from '@tanstack/react-query';
import { getPods } from '@/infrastructure/network/data/matches';

export const usePodsQuery = (poolUuid: string | undefined) => {
	return useQuery({
		queryKey: ['pods', poolUuid],
		queryFn: () => {
			if (!poolUuid) throw new Error('Missing poolUuid');
			return getPods({ poolUuid });
		},
		enabled: !!poolUuid
	});
};
